import { render, staticRenderFns } from "./ChangeQuota.vue?vue&type=template&id=20c7011e&"
import script from "./ChangeQuota.vue?vue&type=script&lang=js&"
export * from "./ChangeQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c7011e')) {
      api.createRecord('20c7011e', component.options)
    } else {
      api.reload('20c7011e', component.options)
    }
    module.hot.accept("./ChangeQuota.vue?vue&type=template&id=20c7011e&", function () {
      api.rerender('20c7011e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Accounts/Modals/ChangeQuota.vue"
export default component.exports